/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["@media only screen and (max-width:767px){.mbflt[_ngcontent-%COMP%]{position:fixed;height:50px;width:100%;bottom:-20px;font-family:Calibre-Bold}.navigate[_ngcontent-%COMP%]{display:block;list-style:none;position:fixed;left:30px;top:25%;z-index:9;margin:0;padding:0}.parent[_ngcontent-%COMP%]   .logomain[_ngcontent-%COMP%]{box-shadow:0 1px 0 #e2e2e2!important}}"];
export { styles as styles };

